import Vue from 'vue'
import VueRouter from 'vue-router'
import pages from './pages.json'
import PostsPage from './components/PostsPage.vue'
import AboutPage from './components/AboutPage.vue'

Vue.use(VueRouter)

const SITE_URL = 'https://www.hyunwookshin.com'

const routes = pages.map(page => ({
  path: page.path,
  name: page.name,
  component: page.name === 'about' ? AboutPage : PostsPage,
  props: { page },
  meta: { page }
}))
routes.push({ path: '*', redirect: '/' })

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition || { x: 0, y: 0 }
  }
})

function setHeadTag(selector, attr, value) {
  const el = document.head.querySelector(selector)
  if (el) {
    el.setAttribute(attr, value)
  }
}

// Keep head tags in sync on client-side navigation; the initial values are
// baked into each page's static HTML at build time (see vue.config.js).
router.afterEach(to => {
  const page = to.meta.page
  if (!page) {
    return
  }
  document.title = page.title
  setHeadTag('meta[name="description"]', 'content', page.description)
  setHeadTag('link[rel="canonical"]', 'href', SITE_URL + page.path)
  setHeadTag('meta[property="og:title"]', 'content', page.title)
  setHeadTag('meta[property="og:description"]', 'content', page.description)
  setHeadTag('meta[property="og:url"]', 'content', SITE_URL + page.path)
})

export default router
